import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import Users from './UsersItems';
class UsersTable extends Component {
  state = {  }
  render() { 
    let { listOfUsers } = this.props
    return ( 
       <Users listOfUsers = {listOfUsers} />
     );
  }
}
 
export default UsersTable;